<template>
  <el-dialog title="移动Key至"
             :visible.sync="paramShow.moveKeyVisible"
             :close-on-click-modal="false"
             width="50%"
             @close="DialogClosed('moveKeyFormRef')">
    <el-form :model="moveKeyForm"
             ref="moveKeyFormRef"
             :rules="moveKeyFormRules"
             label-width="100px">
      <el-form-item label="应用"
                    prop="region">
        <el-select v-model="moveKeyForm.aimAppId">
          <el-option v-for="item in userAppList"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"></el-option>

        </el-select>
      </el-form-item>

    </el-form>
    <span slot="footer">
      <el-button @click="paramShow.moveKeyVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="moveKeyInfo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import http from '@/http/index.js'

export default {
  props: ['paramShow', 'moveKeyItem', 'userAppList'],
  data() {
    return {
      moveKeyForm: {
        aimAppId: null,
        id: null
      },
      moveKeyFormRules: {
        aimAppId: [{ required: true, message: '请选择应用', trigger: 'blur' }]
      }
    };
  },
  methods: {
    moveKeyInfo() {
      this.$refs.moveKeyFormRef.validate(async (valid) => {
        if (!valid) return;
        // 发起修改应用名称请求

        await http.key.move(this.moveKeyForm);
        this.paramShow.moveKeyVisible = false;
        // 刷新数据列表
        // this.getAppList();
        this.$emit('updateList');
        // 提示修改成功
        this.$message.success('移动Key成功！');
      });
    },

    DialogClosed(ref) {
      this.$refs[ref].resetFields();
    }
  },
  created() {
    this.moveKeyForm.id = this.moveKeyItem.id;
  }
};
</script>

<style lang="less" scoped>
</style>
